// Menu items and pages only some accounts get: Custom Domain is for the super
// admin, Healthcare for shops the super admin has switched it on for.
export function canSee(user, needs) {
  if (needs === "superAdmin") return !!user?.is_super_admin;
  if (needs === "healthcare") return !!(user?.is_super_admin || user?.healthcare_module_enabled);
  return true;
}
